import React, { useContext, useState } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { useMutation } from "@apollo/client";
//icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_EXPENSE_GROUP } from "../../Schema/ExpenseGroup";
import { translateLauguage } from "../../Function/Translate";
import CropImageFile from "../CropImage/CropImageFile";
// import { SelectEmployee } from "../Include/DynamicSelect";
import { UPDATE_EXPENSE_GROUP } from "../../Schema/ExpenseGroup";
import { useEffect } from "react";
export default function CreateExpenseGroup({
  open,
  handleClose,
  setRefetch,
  dailogTitle,
  editData,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createGroupExpense] = useMutation(CREATE_EXPENSE_GROUP, {
    onCompleted: ({ createGroupExpense }) => {
      setLoading(false);
      // console.log("createGroupExpense::", createGroupExpense);
      if (createGroupExpense?.status === true) {
        setAlert(true, "success", createGroupExpense?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createGroupExpense?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  const [updateGroupExpense] = useMutation(UPDATE_EXPENSE_GROUP, {
    onCompleted: ({ updateGroupExpense }) => {
      setLoading(false);
      // console.log("updateGroupExpense::", updateGroupExpense);
      if (updateGroupExpense?.status === true) {
        setAlert(true, "success", updateGroupExpense?.message);
        handleClose();
        resetForm();
        // setRefetch();
      } else {
        setAlert(true, "error", updateGroupExpense?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  const CreateExpenseGroup = Yup.object().shape({
    code: Yup.string().required("required!"),
    title: Yup.string().required("required!"),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      code: "",
      title: "",
      remark: "",
    },
    validationSchema: CreateExpenseGroup,
    onSubmit: async (values) => {
        // console.log("values:::", values);
      setLoading(true);
      if (dailogTitle === "Create") {
        createGroupExpense({
          variables: {
            ...values,
          },
        });
      } else {
        updateGroupExpense({
          variables: {
            id: editData?._id,
            ...values,
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  useEffect(() => {
    if (editData) {
      setFieldValue("code", editData?.code);
      setFieldValue("title", editData?.title);
      setFieldValue("remark", editData?.remark);
    }
  }, [editData]);

  return (
    <Dialog open={open} className="dialog-container" maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              {dailogTitle === "Create"
                ? t("modal_title_create_expense_group")
                : t("modal_title_update_expense_group")}
            </Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">
                  Code
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder="code"
                  {...getFieldProps("code")}
                  error={Boolean(touched.code && errors.code)}
                  helperText={touched.code && errors.code}
                  multiline
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">
                  {t("thead_title")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("label_title")}
                  {...getFieldProps("title")}
                  error={Boolean(touched.title && errors.title)}
                  helperText={touched.title && errors.title}
                  multiline
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography className="field-title">
                  {t("thead_remark")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("label_remark")}
                  {...getFieldProps("remark")}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {dailogTitle === "Create" ? t("create") : t("update")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
